<template>
  <div>
    <div class="background-container">
      <div class="inner">
        <div class="about-title">
          잠자는 국회 | 입법평론<span class="about-title-dot"></span>
        </div>
      </div>
    </div>
    <div class="about-content">
      <!-- <div class="about-vertical-line"></div> -->
      <div>
        <div class="about-content-inner">
          <div class="about-1">
            <span class="about-blue">잠자는 국회</span>는
            <span class="about-blue">국회 입법 모니터링 현황판</span
            >입니다.<br />
            국회의원의
            <span class="about-blue"
              >법안 발의 및 처리와 관련된 각종 데이터를 제공</span
            >합니다.
          </div>

          <div class="about-2">
            국회에서는, 수많은 법이 발의만 된 상태에서 방치<span class="thin"
              >되고 있습니다.</span
            ><br />
            법을 많이 발의한 국회의원이 열심히 일한 의원으로 평가받습니다.<br />
            <span class="thin">그러나 꼭 그렇지는 않습니다. 많은 의원들이</span>
            법안 발의에만 열중할 뿐, 처리 노력은 뒷전<span class="thin"
              >입니다.</span
            >
          </div>

          <div class="about-1">
            <span class="about-blue">잠자는 국회</span>의
            <span class="about-blue">목표</span>
          </div>
          <div class="about-2">
            발의 ‘건수’만 중시하는 국회의 나쁜 관행을 바로잡고, 국회의원의 입법
            책임성<span class="thin"
              >을 조금이라도<br />높이는 것입니다. 이를 위해</span
            >
            국회의 법안 처리현황을 다양한 지표로 공개<span class="thin"
              >합니다.</span
            >
          </div>

          <div class="about-1">
            <span class="about-blue">잠자는 국회</span>는
            <span class="about-green">입법평론과 함께</span> 합니다.
          </div>
          <div class="about-2">
            입법평론<span class="thin">은</span> 국회의원의 입법 활동<span
              class="thin"
              >에 대한</span
            >
            분석과 해설<span class="thin">입니다.</span><br />
            <span class="thin">숫자가 아닌</span> 내용 중심의 의정활동 평가<span
              class="thin"
              >를 위한</span
            >
            기초자료<span class="thin">입니다.</span>
          </div>

          <div class="about-1">
            <span class="about-blue">잠자는 국회</span>와
            <span class="about-green">입법평론</span>은
          </div>

          <div class="about-2">
            ‘좋은 법’<span class="thin">으로</span> ‘일하는 국회’<span
              class="thin"
              >를 만들어 가고자 합니다.</span
            >
            꼭 필요한 법이, 충분히 검토되어,<br />신중하게 발의되고, 발의된
            법안은 꼭 처리하는 상식적인 국회를 기대합니다.
          </div>

          <div class="about-footer-title">시민 여러분, 함께 해 주십시오.</div>
        </div>
      </div>
      <!-- <div class="about-vertical-line right"></div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutPage",
};
</script>

<style scoped>
.background-container {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../assets/img/about-main.jpg");

  background-size: cover;
  background-position: center -110px;
  background-attachment: fixed;
  height: 600px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 1040px) {
    background-attachment: initial;
  }
}

.about-content-inner {
  max-width: 132vw;
  width: 100%;
  word-break: keep-all;
  padding: 0 5vw;
}

.about-title {
  position: relative;
  font-family: GmarketSansMedium;
  font-size: 70px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff;

  @media only screen and (max-width: 1040px) {
    font-size: 7vw;
  }
}

.inner {
  padding-top: 70px;
  display: flex;
  height: 100%;
  align-items: center;
}

.about-title-dot {
  display: inline-block;
  position: absolute;
  width: 2vw;
  height: 2vw;
  background-color: #005aab;
  border-radius: 50%;
  right: -2vw;
  top: -2vw;
}

.about-content {
  padding-top: 8vw;
  padding-bottom: 10vw;
  display: flex;
  position: relative;
  justify-content: center;
}

.about-1 {
  font-family: GmarketSansMedium;
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1px;
  text-align: left;
  color: #000000;
  margin-bottom: 20px;

  @media only screen and (max-width: 1040px) {
    text-align: center;
    font-size: 30px;
  }

  @media only screen and (max-width: 425px) {
    font-size: 20px;
  }
}

.about-blue {
  color: #005aab;
}

.about-green {
  color: #0db2ab;
}

.about-2 {
  font-family: GmarketSansMedium;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #666;
  margin-bottom: 50px;

  @media only screen and (max-width: 1040px) {
    text-align: center;
    font-size: 20px;
  }

  @media only screen and (max-width: 425px) {
    font-size: 18px;
  }
}

.thin {
  font-weight: 300;
}

.about-footer-title {
  font-family: GmarketSansMedium;
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1px;
  text-align: left;
  color: #000;
  margin-top: 100px;

  @media only screen and (max-width: 1040px) {
    text-align: center;
    font-size: 30px;
  }

  @media only screen and (max-width: 425px) {
    font-size: 20px;
  }
}

.about-vertical-line {
  width: 1px;
  height: 100%;
  background-color: #e6e6e6;
  position: absolute;
  left: 200px;
  top: 0;

  @media only screen and (max-width: 1185px) {
    display: none;
  }
}

.about-vertical-line.right {
  right: 200px;
  left: auto;
}
</style>
